// Notifications push (web push standard, VAPID). Fonctionne sur Chrome/Firefox/Edge
// partout, et sur Safari iOS à partir d'iOS 16.4 — mais UNIQUEMENT si le site a été
// ajouté à l'écran d'accueil (une page Safari "normale" ne peut pas demander la
// permission notifications sur iOS).
import axios from 'axios';

var API_URL = process.env.REACT_APP_BACKEND_URL;

export function isPushSupported() {
  return typeof window !== 'undefined' && 'serviceWorker' in navigator && 'PushManager' in window && 'Notification' in window;
}

export function isIos() {
  return /iphone|ipad|ipod/i.test(window.navigator.userAgent);
}

export function isStandalone() {
  return window.navigator.standalone === true || window.matchMedia('(display-mode: standalone)').matches;
}

function urlBase64ToUint8Array(base64String) {
  var padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  var base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  var rawData = window.atob(base64);
  var outputArray = new Uint8Array(rawData.length);
  for (var i = 0; i < rawData.length; i++) outputArray[i] = rawData.charCodeAt(i);
  return outputArray;
}

// Enregistre le service worker, demande la permission, s'abonne au push et
// envoie l'abonnement au backend. Doit être appelé depuis un clic utilisateur.
export function subscribeToPush() {
  if (!isPushSupported()) return Promise.reject(new Error('push-unsupported'));

  return navigator.serviceWorker.register('/service-worker.js')
    .then(function () { return navigator.serviceWorker.ready; })
    .then(function () { return Notification.requestPermission(); })
    .then(function (permission) {
      if (permission !== 'granted') throw new Error('permission-denied');
      return axios.get(API_URL + '/api/push/vapid-public-key');
    })
    .then(function (res) {
      return navigator.serviceWorker.ready.then(function (reg) {
        return reg.pushManager.subscribe({
          userVisibleOnly: true,
          applicationServerKey: urlBase64ToUint8Array(res.data.public_key),
        });
      });
    })
    .then(function (subscription) {
      return axios.post(API_URL + '/api/push/subscribe', subscription.toJSON(), { withCredentials: true });
    });
}

export function getPushSubscription() {
  if (!isPushSupported()) return Promise.resolve(null);
  return navigator.serviceWorker.getRegistration().then(function (reg) {
    if (!reg) return null;
    return reg.pushManager.getSubscription();
  }).catch(function () { return null; });
}
